import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository.ts'
import {
  type DashboardClassroomDiagnosticTrigger,
  DashboardClassroomDiagnosticTriggerInput
} from '@/core/domain/dashboard/DashboardClassroomDiagnosticTrigger.ts'

export class CreateDashboardClassroomDiagnosticTriggerUseCase {
  private readonly dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(
    classroomId: number,
    input: DashboardClassroomDiagnosticTriggerInput
  ): Promise<DashboardClassroomDiagnosticTrigger[]> {
    return await this.dashboardRepository.createDashboardClassroomDiagnosticTrigger(
      classroomId,
      input
    )
  }
}
